import { customElement } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { style } from './dropdown-menu-group.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


@customElement('cse-dropdown-menu-group')
export class CSEDropdownMenuGroup extends LitElement {
  static override styles: CSSResultGroup = [fontStyles, hostStyle, style]

  override render() {
    return html`
      <div class="cse-dropdown-menu-group">
        <slot name="title" class="title font-heading-6"></slot>
        <slot class="options"></slot>
        <cse-divider orientation="horizontal"></cse-divider>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-dropdown-menu-group': CSEDropdownMenuGroup
  }
}
